import React from 'react';
import { MdLoop } from 'react-icons/md';

import styles from './_LoadingIndicator.module.scss';

type LoadingIndicatorProps = {
  loadingText?: string;
};

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ loadingText }) => (
  <div className="tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-4 tw-justify-center tw-items-center">
    <MdLoop className={styles.customSpinner} size={40} />
    {loadingText && <div>{loadingText}</div>}
  </div>
);

export default LoadingIndicator;
